(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const contadores = document.querySelectorAll('.cabecera-bellucci [data-contador-carrito]');
    if (!contadores.length) return;

    const actualizarContadores = (cantidad) => {
      contadores.forEach((el) => {
        el.textContent = cantidad;
        el.setAttribute('data-cantidad', cantidad);
        if (cantidad > 0) {
          el.removeAttribute('hidden');
        } else {
          el.setAttribute('hidden', '');
        }
      });
    };

    const sincronizarCarrito = async () => {
      try {
        const raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const respuesta = await fetch(raiz + 'cart.js', {
          headers: { Accept: 'application/json' }
        });
        if (!respuesta.ok) return;
        const datos = await respuesta.json();
        actualizarContadores(datos.item_count || 0);
      } catch (e) {}
    };

    document.addEventListener('cart:updated', sincronizarCarrito);
    document.addEventListener('cart:refresh', sincronizarCarrito);
    document.addEventListener('cart:added', sincronizarCarrito);

    const fetchOriginal = window.fetch;
    if (typeof fetchOriginal === 'function') {
      window.fetch = function () {
        const promesa = fetchOriginal.apply(this, arguments);
        const url = arguments[0];
        if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear'))) {
          promesa.then(() => sincronizarCarrito()).catch(() => {});
        }
        return promesa;
      };
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sectionsmenu-colecciones"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const menus = document.querySelectorAll('.menu-colecciones');
    if (!menus.length) return;

    menus.forEach((menu) => {
      const items = menu.querySelectorAll('[data-submenu-item]');
      if (!items.length) return;

      const cerrarTodos = () => {
        items.forEach((item) => {
          item.setAttribute('data-abierto', 'false');
          const toggle = item.querySelector('[data-submenu-toggle]');
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
        });
      };

      items.forEach((item) => {
        const toggle = item.querySelector('[data-submenu-toggle]');
        if (!toggle) return;

        toggle.addEventListener('click', (e) => {
          const tieneHover = window.matchMedia('(hover: hover)').matches;
          if (tieneHover) return;

          const abierto = item.getAttribute('data-abierto') === 'true';

          if (!abierto) {
            e.preventDefault();
            cerrarTodos();
            item.setAttribute('data-abierto', 'true');
            toggle.setAttribute('aria-expanded', 'true');
          }
        });
      });

      document.addEventListener('click', (e) => {
        if (!menu.contains(e.target)) cerrarTodos();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') cerrarTodos();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
